/* src/app/components/public/public-menu/public-menu.component.scss */
.navbar-collapse {
  background: #fff;
  padding: 20px;
}
@media screen and (min-width: 768px) {
  .navbar-collapse {
    background: transparent;
    padding: 0;
  }
}
/*# sourceMappingURL=public-menu.component.css.map */
